import styled, { css } from 'styled-components';

export const FilterWrapper = styled.div`
  ${({ theme }) => css`
    border-radius: 16px;
    background: ${theme.v2.colors.white.primary};
    margin: 0 40px;

    @media(max-width: ${theme.v2.breakpoints.md}) {
      margin: 0;
    }
  `};
`;

export const AcademyPassFilterHandlerWrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.palette.white.light} 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 3px ${theme.shadows.grey.light};
    margin-top: 0px;
    padding: 12px 24px;
  `}
`;
